// ============================================================
// API Service
// The ONLY file in the frontend that talks to the backend.
// Zero business logic — just request/response handling.
// ============================================================

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// ── OTP ──────────────────────────────────────────────────
export async function requestOtp(email, purpose) {
  const res = await fetch(`${API_URL}/otp/request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, purpose })
  });
  return res.json();
}

export async function verifyOtp(email, code, purpose) {
  const res = await fetch(`${API_URL}/otp/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code, purpose })
  });
  return res.json();
}

// ── FREE TRIAL ────────────────────────────────────────────
export async function getTrialQuestions() {
  const res = await fetch(`${API_URL}/trial/questions`);
  if (!res.ok) throw new Error('Could not load trial questions');
  return res.json();
}

export async function submitTrialAnswers(email, answers) {
  const res = await fetch(`${API_URL}/trial/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, answers })
  });
  return res.json();
}

// ── PAYMENT ───────────────────────────────────────────────
export async function getCurrentPrice() {
  const res = await fetch(`${API_URL}/payment/price`);
  if (!res.ok) throw new Error('Could not fetch pricing');
  return res.json();
}

export async function createPaymentOrder(userId) {
  const res = await fetch(`${API_URL}/payment/create-order`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId })
  });
  if (!res.ok) throw new Error('Could not create payment order');
  return res.json();
}

export async function confirmPayment(razorpayOrderId, razorpayPaymentId, razorpaySignature) {
  const res = await fetch(`${API_URL}/payment/confirm`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ razorpayOrderId, razorpayPaymentId, razorpaySignature })
  });
  return res.json();
}

// ── SESSION (paid assessment) ────────────────────────────
export async function startSession(userId, experienceBand, careerTrack, industryType, industry, originCompanyType, gccStatus, razorpayOrderId, name, email, phone) {
  const res = await fetch(`${API_URL}/session/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, experienceBand, careerTrack, industryType, industry, originCompanyType, gccStatus, razorpayOrderId, name, email, phone })
  });
  if (!res.ok) {
    const errData = await res.json().catch(() => ({}));
    throw new Error(errData.error || 'Could not start assessment');
  }
  return res.json();
}

export async function getQuestion(sessionId, questionNumber) {
  const res = await fetch(`${API_URL}/session/${sessionId}/question/${questionNumber}`);
  if (!res.ok) throw new Error('Could not load question');
  return res.json();
}

export async function saveAnswer(sessionId, questionNumber, responseKey) {
  const res = await fetch(`${API_URL}/session/${sessionId}/answer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ questionNumber, responseKey })
  });
  if (!res.ok) throw new Error('Could not save answer');
  return res.json();
}

export async function submitSession(sessionId) {
  const res = await fetch(`${API_URL}/session/${sessionId}/submit`, {
    method: 'POST'
  });
  return res.json();
}

export async function getReport(sessionId) {
  const res = await fetch(`${API_URL}/report/${sessionId}`);
  if (!res.ok) throw new Error('Could not load report');
  return res.json();
}

// ── FEEDBACK ──────────────────────────────────────────────
export async function submitFeedback(name, email, rating, feedbackText) {
  const res = await fetch(`${API_URL}/feedback/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, rating, feedbackText })
  });
  return res.json();
}

// ── CONTACT ───────────────────────────────────────────────
export async function submitContact(name, email, category, message) {
  const res = await fetch(`${API_URL}/contact/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, category, message })
  });
  return res.json();
}
